document.addEventListener("DOMContentLoaded", function () {
  const steps = document.querySelectorAll(".block_audit-steps");
  const nextBtns = document.querySelectorAll(".block_audit-button-next");
  const prevBtns = document.querySelectorAll(".block_audit-button-prev");
  const submitBtn = document.querySelector(".block_button_submit");
  const progressBar = document.querySelector(".progress-bar");
  const percentDisplay = document.querySelector(".block_progressbar-percentage");

  let currentStep = 0;

  function scrollToStep(index) {
    const offset = 1000;
    const rect = steps[index].getBoundingClientRect();
    const scrollTop = window.scrollY + rect.top - offset;
    window.scrollTo({ top: scrollTop, behavior: "smooth" });
  }

  function showStep(index) {
    steps.forEach((step, i) => {
      step.classList.toggle("hidden", i !== index);
    });
    const percent = Math.round(((index + 1) / steps.length) * 100);
    progressBar.style.width = percent + "%";
    if (percentDisplay) percentDisplay.textContent = percent + "%";
    scrollToStep(index);
  }

  function clearErrors(stepEl) {
    stepEl.querySelectorAll(".has-error, .checkbox-error, .other-text-error, .block-other-error, .checkbox-label-error").forEach(el => {
      el.classList.remove("has-error", "checkbox-error", "other-text-error", "block-other-error", "checkbox-label-error");
    });
  }

  function validateStep(stepEl) {
    clearErrors(stepEl);
    let valid = true;

    const requiredInputs = stepEl.querySelectorAll("input[required], textarea[required]");
    requiredInputs.forEach(input => {
      if (!input.value.trim()) {
        input.classList.add("has-error");
        valid = false;
      }
    });

    // ✅ EMAIL FORMAT VALIDATION
    const emailInput = stepEl.querySelector("#ContactForm-email");
    if (emailInput && emailInput.offsetParent !== null) {
      const emailVal = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailVal)) {
        emailInput.classList.add("has-error");
        valid = false;
      } else {
        emailInput.classList.remove("has-error");
      }
    }

    // ✅ PHONE FORMAT VALIDATION
    const phoneInput = stepEl.querySelector("#ContactForm-phone");
    if (phoneInput && phoneInput.offsetParent !== null) {
      const phoneVal = phoneInput.value.trim();
      const phoneRegex = /^[0-9]{7,15}$/;
      if (!phoneRegex.test(phoneVal)) {
        phoneInput.classList.add("has-error");
        valid = false;
      } else {
        phoneInput.classList.remove("has-error");
      }
    }

    // ✅ WEBSITE FIELD VALIDATION (optional but must be valid if filled)
    const websiteInput = stepEl.querySelector("#ContactForm-website");
    if (websiteInput && websiteInput.offsetParent !== null) {
      const websiteVal = websiteInput.value.trim();
      const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

      if (websiteVal !== "" && !urlRegex.test(websiteVal)) {
        websiteInput.classList.add("has-error");
        valid = false; 
      } else {
        websiteInput.classList.remove("has-error");
      }
    }

    // Checkbox validation
    const checkboxes = stepEl.querySelectorAll("input[type='checkbox']");
    if (checkboxes.length) {
      const isChecked = Array.from(checkboxes).some(cb => cb.checked);
      if (!isChecked) {
        checkboxes.forEach(cb => {
          cb.classList.add("checkbox-error");
          const label = stepEl.querySelector(`label[for="${cb.id}"]`);
          if (label) label.classList.add("checkbox-label-error");
        });
        valid = false;
      }

      // Check for 'Other' checkbox and input
      checkboxes.forEach(cb => {
        const parent = cb.closest(".block_audit-other-input");
        if (cb.checked && parent) {
          const otherInputBox = parent.querySelector(".block_select-other");
          const textInput = otherInputBox?.querySelector("input[type='text']");
          if (textInput && textInput.value.trim() === "") {
            textInput.classList.add("other-text-error");
            otherInputBox.classList.add("block-other-error");
            cb.classList.add("checkbox-error");
            const label = stepEl.querySelector(`label[for="${cb.id}"]`);
            if (label) label.classList.add("checkbox-label-error");
            valid = false;
          }
        }
      });
    }

    // Radio validation
    const radios = stepEl.querySelectorAll("input[type='radio']");
    if (radios.length) {
      const groupNames = new Set();
      radios.forEach(r => groupNames.add(r.name));
      groupNames.forEach(name => {
        const group = stepEl.querySelectorAll(`input[name='${name}']`);
        const isAnyChecked = Array.from(group).some(r => r.checked);
        if (!isAnyChecked) {
          group.forEach(r => {
            const label = stepEl.querySelector(`label[for="${r.id}"]`);
            if (label) label.classList.add("checkbox-label-error");
          });
          valid = false;
        }
      });
    }

    if (!valid) scrollToStep(currentStep);
    return valid;
  }

  function disableHiddenRequiredInputs() {
    document.querySelectorAll('.block_audit-steps.hidden input[required], .block_audit-steps.hidden textarea[required]').forEach((el) => {
      el.setAttribute('data-required-backup', 'true');
      el.removeAttribute('required');
    });
  }

  function restoreHiddenRequiredInputs() {
    document.querySelectorAll('[data-required-backup="true"]').forEach((el) => {
      el.setAttribute('required', 'true');
      el.removeAttribute('data-required-backup');
    });
  }

  document.querySelectorAll(".block_audit-other-input input[type='checkbox']").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const parent = checkbox.closest(".block_audit-other-input");
      const otherInputBox = parent.querySelector(".block_select-other");
      if (checkbox.checked) {
        otherInputBox.classList.remove("hidden");
      } else {
        otherInputBox.classList.add("hidden");
        const textInput = otherInputBox.querySelector("input");
        if (textInput) textInput.value = "";
      }
    });
  });

  nextBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const currentBlock = steps[currentStep];
      if (validateStep(currentBlock)) {
        if (currentStep < steps.length - 1) {
          currentStep++;
          showStep(currentStep);
        }
      }
    });
  });

  prevBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    });
  });

  if (submitBtn) {
    submitBtn.addEventListener("click", function (e) {
      disableHiddenRequiredInputs();
      const currentBlock = steps[currentStep];
      const isValid = validateStep(currentBlock);
      restoreHiddenRequiredInputs();

      if (!isValid) {
        e.preventDefault();
        scrollToStep(currentStep);
      } else {
        const percent = 100;
        progressBar.style.width = percent + "%";
        if (percentDisplay) percentDisplay.textContent = percent + "%";
        console.log("percent", percent);
      }
    });
  }

  showStep(currentStep);
});